import { OccurrenceCard } from '../OccurrenceCard';

export const DailyOccurrence = ({ events = [], source = '', showAssigner = false }) => {
  //Daily occurrence will have one occurrence per time slot on the definition
  if (!events || events.length === 0) {
    return (
      <div
        className="font-italic text-center flex align-flex-start justify-content-center pt-2"
        style={{
          opacity: 0.5,
          minHeight: 200,
        }}
      >
        No occurrences for this day.
      </div>
    );
  }
  const sortedEvents = [...events].sort((a, b) => a.start - b.start);
  return (
    <div style={{ minHeight: 200 }}>
      {sortedEvents.map((event, idx) => (
        <OccurrenceCard
          key={idx}
          event={event}
          source={source || 'occurrences'}
          showAssigner={showAssigner}
        />
      ))}
    </div>
  );
};
